<template>
  <div id="content-wrap" class="content-wrapper">
    <div v-show="noAccount" class="example-modal">
      <div class="modal" style="display: block">
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Đồng Bộ FaceBook</h4>
            </div>
            <div class="modal-body">
              <a href="#" @click="popUp" class="btn btn-block btn-social btn-facebook">
                <i class="fa fa-facebook"></i>Connect with Facebook
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!noAccount" class="container-fluid p-4">
      <div class="row">
        <AccountInfo :account="account" class="col-md-3" @remove-account="removeAccount"/>
        <va-custom-tab class="col-md-9">
          <div slot="content"
               class="active"
               id="tab_1"
               title="FanPage">
            <div class="row">
              <div class="col-md-7 search-top">
                <div class="input-group input-group-sm pull-right">
                  <input v-model="filterData.page_id_name" type="text" class="form-control" id="Info" name="Info"
                         placeholder="Tìm PageID, Tên Fanpage">
                  <button type="button" class="btn btn-green btn-flat" @click="search">
                    <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm Kiếm
                  </button>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col">
                <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                         show-empty>
                  <template #table-busy>
                    <div class="text-center my-2 mt-5 mb-5">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Đang tải...</strong>
                    </div>
                  </template>
                  <template #empty="scope">
                    <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button class="btn-sm btn-pink" v-b-tooltip.hover title="Xoá" @click="removeFbPage(data.item)">
                      <span class="glyphicon glyphicon-trash"></span>
                    </b-button>
                  </template>
                  <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at | format_date }}
                  </template>
                  <template v-slot:cell(is_subscribed)="data">
                    <div>
                      <div class="custom-control custom-switch custom-switch-md">
                        <input type="checkbox" class="custom-control-input" id="customSwitch4" @change="toggle(data.item.id, data.item.is_subscribed)"
                               v-model="data.item.is_subscribed" />
                        <label class="custom-control-label" for="customSwitch4">Đăng ký</label>
                      </div>
                    </div>
                  </template>
                </b-table>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="page-size-container">
                    <span>Hiển thị</span>
                    <b-form-select
                      id="pageSize"
                      v-model="pageSize"
                      :options="pageSizes"
                      required
                    ></b-form-select>
                    <span>  dòng</span>
                  </div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRow"
                    :per-page="pageSize"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </va-custom-tab>

      </div>
    </div>

  </div>
</template>

<script>
import AccountInfo from './AccountInfo'
import FacebookPageApi from '../../api/facebookPage'
import VACustomTab from 'va/components/VACustomTab.vue'
import Utils from '../../common/utils'

const SUCCESS_CODE = 0
const FAIL_CODE = 5006

export default {
  name: 'FacebookConnect',
  components: {
    AccountInfo,
    'va-custom-tab': VACustomTab,
  },
  data () {
    return {
      filterData: {
        page_id_name: null,
      },
      items: [],
      fields: [
        {
          key: 'page_id',
          label: 'Page ID'
        },
        {
          key: 'page_name',
          label: 'Tên fanpage'
        },
        {
          key: 'is_subscribed',
          label: 'Đăng ký'
        },
        {
          key: 'created_at',
          label: 'Ngày tạo'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      emailSynstax: [],
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      newItemData: {
        id: null,
        page_id: '',
        page_name: '',
        is_subscribed: '',
      },
      account: {
        fbLink: 'http://facebook.com/2265977350159541',
        picture_url: 'https://graph.facebook.com/2265977350159541/picture?height=120&amp;width=120',
        name: 'Cao Xuân Anh',
        username: 'zy6661',
        email: 'zhaoyunhp93@yahoo.com',
        phone: '0869786848',
        package: 'TRIAL',
        expireDate: '07/07/2023',
        fanPageCount: '5',
        userCount: '5',
        showroomCount: '5',
      },
      noAccount: true,
    }
  },
  mounted () {
    this.addAccount()
  },
  methods: {
    filter () {
      this.loading = true
      FacebookPageApi.filter(this.filterData, this.currentPage - 1, this.pageSize)
        .then(res => {
          this.items = res.data.data.records
          this.totalRow = res.data.data.total
        })
        .catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    search () {
      this.filter()
    },
    toggle (id, newValue) {
      const data = {id: id, is_subscribed: newValue}
      this.loading = true
      FacebookPageApi.update(data)
        .then((res) => {
        })
        .catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    popUp () {
      window.open('http://crm.ity.vn/api/fb/login/', 'Facebook Login', 'width=600,height=300')
      this.addAccount()
    },
    removeFbPage (item) {
      this.loading = true
      FacebookPageApi.remove(item.id)
        .then((res) => {
          Utils.successToast(this.$bvToast)
          this.filter()
        })
        .catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    removeAccount () {
      this.noAccount = true
    },
    addAccount () {
      FacebookPageApi.get_account()
        .then((res) => {
          this.account = res.data.data
          if (res.data.code === SUCCESS_CODE) {
            this.noAccount = false
            this.filter()
          }
        })
        .catch((err) => {
          if (err.response.status === 400) {
            if (err.response.data.code === FAIL_CODE) {
              Utils.failedToast(this.$bvToast, 'FanPage', 'Không tồn tại tài khoản. Vui lòng liên hệ admin')
            }
          } else {
            Utils.failedToast(this.$bvToast, 'FanPage', 'Lỗi hệ thống')
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
.example-modal .modal {
  background: transparent !important;
}

.example-modal .modal {
  position: relative;
  top: auto;
  bottom: auto;
  right: auto;
  left: auto;
  display: block;
  z-index: 1;
}

.btn-facebook:hover {
  color: #fff;
  background-color: #2d4373;
  border-color: rgba(0, 0, 0, 0.2);
}

.btn-facebook {
  color: #fff;
  background-color: #3b5998;
  border-color: rgba(0, 0, 0, 0.2);
}

.example-modal .modal-header {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
  justify-content: normal;
}

.btn-link:hover {
  text-decoration: none;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.list-group-unbordered > .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.btn-facebook {
  width: 100%;
  color: #fff;
  background-color: #3b5998;
  border-color: rgba(0, 0, 0, 0.2);
}

.btn-social > :first-child {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 32px;
  line-height: 34px;
  font-size: 1.6em;
  text-align: center;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}

.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@mixin switch($res: 'sm') {
  $index: 1rem;
  $mainVal: 1rem;

  @if $res == 'md' {
    $index: 2rem;
    $mainVal: 1.5rem;
  } @else if $res == 'lg' {
    $index: 3rem;
    $mainVal: 2rem;
  } @else if $res == 'xl' {
    $index: 4rem;
    $mainVal: 2.5rem;
  }

  .custom-control-label {
    padding-left: #{$index};
    padding-bottom: #{$mainVal};
  }

  .custom-control-label::before {
    height: $mainVal;
    width: calc(#{$index} + 0.75rem);
    border-radius: $mainVal * 2;
  }

  .custom-control-label::after {
    width: calc(#{$mainVal} - 4px);
    height: calc(#{$mainVal} - 4px);
    border-radius: calc(#{$index} - (#{$mainVal} / 2));
  }

  .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(calc(#{$mainVal} - 0.25rem));
  }
}

// YOU CAN PUT ALL RESOLUTION HERE
// sm - DEFAULT, md, lg, xl
.custom-switch.custom-switch-sm {
  @include switch();
}

.custom-switch.custom-switch-md {
  @include switch('md');
}

.custom-switch.custom-switch-lg {
  @include switch('lg');
}

.custom-switch.custom-switch-xl {
  @include switch('xl');
}
</style>



// WEBPACK FOOTER //
// src/views/social_network/FacebookConnect.vue